import styled from 'styled-components'
import { rotation } from 'builder/styles/keyframes'
import SPINNER_URL from './assets/spinner.svg'
import SPINNER_BLACK_URL from './assets/spinner-black.png'
import SPINNER_LIGHT_URL from './assets/spinner-light.png'
import SPINNER_WHITE_URL from './assets/spinner-white.png'
import SPINNER_INDIGO_URL from './assets/spinner-indigo.png'

export const Spinner = styled.div<{ $width?: string; $height?: string }>`
  width: ${({ $width }) => $width || '32px'};
  height: ${({ $height }) => $height || '32px'};
  background-image: url(${SPINNER_URL});
  background-size: 100% 100%;
  background-position: center center;
  animation: ${rotation} 0.6s infinite linear;
`

export const SpinnerBlack = styled(Spinner)`
  background-image: url(${SPINNER_BLACK_URL});
`

export const SpinnerLight = styled(Spinner)`
  background-image: url(${SPINNER_LIGHT_URL});
`

export const SpinnerIndigo = styled(Spinner)`
  background-image: url(${SPINNER_INDIGO_URL});
`

export const SpinnerWhite = styled(Spinner)`
  background-image: url(${SPINNER_WHITE_URL});
`
